import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

import { StockDesktopTable } from "./stock-desktop-table";
import {
  StockSearchFilters,
  StockTypeTabs,
  type StockFilterTab,
} from "./stock-filter-bar";
import { StockMobileList } from "./stock-mobile-list";

import type { StockItem } from "./types";

interface Props {
  items: StockItem[];
  query: string;
  onQueryChange: (query: string) => void;
  typeFilter: string;
  onTypeFilterChange: (type: StockFilterTab) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  onEditMinStock?: (item: StockItem) => void;
  onViewStockCard?: (item: StockItem) => void;
}

export function StockTable({
  items,
  query,
  onQueryChange,
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
  onEditMinStock,
  onViewStockCard,
}: Props) {
  const isMobile = useIsMobile();
  const rowsProps = { rows: items, onEditMinStock, onViewStockCard };

  return (
    <Card className="shadow-xs">
      {/* minmax(0,1fr): the type tabs scroll instead of widening the card on mobile */}
      <CardHeader className="pb-3 grid-cols-[minmax(0,1fr)]">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <CardTitle className="text-base font-semibold">
              Persediaan Stok Barang
            </CardTitle>
            <CardDescription className="text-xs">
              Daftar saldo stok bahan baku dan produk siap jual di toko
              (append-only ledger).
            </CardDescription>
          </div>

          <StockTypeTabs
            typeFilter={typeFilter}
            onTypeFilterChange={onTypeFilterChange}
          />
        </div>

        <StockSearchFilters
          query={query}
          onQueryChange={onQueryChange}
          statusFilter={statusFilter}
          onStatusFilterChange={onStatusFilterChange}
        />
      </CardHeader>

      <CardContent className="overflow-auto p-0">
        {isMobile ? (
          <StockMobileList {...rowsProps} />
        ) : (
          <StockDesktopTable {...rowsProps} />
        )}
      </CardContent>
    </Card>
  );
}
